import {
  type ZoneSegment,
  type ZoneSegmentIntervalType,
  type ZoneSegmentType,
} from '@rouvydev/web-components/utils'

const workoutSegmentTypeMap: Record<string, ZoneSegmentType> = {
  ftp: 'FTP',
  power: 'POWER',
  wkg: 'WKG',
  slope: 'POWER',
}

const workoutSegmentIntervalTypeMap: Record<string, ZoneSegmentIntervalType> = {
  constant: 'CONSTANT',
  freeRide: 'FREE_RIDE',
  ramp: 'RAMP',
}

export function normalizeWorkoutSegment(
  segment: Record<string, string>,
): ZoneSegment {
  return {
    valueStart: Number(segment['primaryMin']),
    valueEnd: Number(segment['primaryMax']),
    duration: Number(segment['duration']),
    type: workoutSegmentTypeMap[segment['primaryType']] as ZoneSegmentType,
    intervalType: workoutSegmentIntervalTypeMap[
      segment['intervalType']
    ] as ZoneSegmentIntervalType,
  }
}
